import ContractsTaxiForwardingContractAddRequest, {
  ContractsTaxiForwardingContractAddRequestBody,
} from "./contracts-taxi-forwarding-contract-add.request";

const createBody = (
  request: ContractsTaxiForwardingContractAddRequest,
): ContractsTaxiForwardingContractAddRequestBody => {
  return {
    consumerTaxiId: request.consumerTaxiId,
    disabled: request.disabled,
    displayName: request.displayName,
    distanceRate: request.distanceRate,
    haltingTimeAfterMinutes: request.haltingTimeAfterMinutes,
    haltingTimeRate: request.haltingTimeRate,
    isPartner: request.isPartner,
    model: request.model,
    priority: request.priority,
    producerTaxiId: request.producerTaxiId,
    validSince: request.validSince,
    validTo: request.validTo,
  };
};

const contractsTaxiForwardingContractAddRequestFactory = {
  createBody,
};

export default contractsTaxiForwardingContractAddRequestFactory;
